// 260805nrai: DWE freigabe confirm modal (Freigeben / optional Bearbeiten / Abbrechen)

function todoDweCompleteModal() {
  return $('#todo_dwe_complete_modal');
}

function openTodoDweCompleteModal($link) {
  const modal = todoDweCompleteModal();
  if (!modal.length) {
    return;
  }

  const data = $link.data();
  modal.data('todoId', data.todoId);
  modal.data('editUrl', data.editUrl);
  modal.data('completeUrl', data.completeUrl);

  $('#todo_dwe_complete_title').text(data.title || '—');
  $('#todo_dwe_complete_requester').text(data.requester || '—');
  $('#todo_dwe_complete_exception_until').text(data.exceptionUntil || '—');
  $('#todo_dwe_complete_window_until').text(data.windowUntil || '—');
  $('#todo_dwe_complete_begruendung').text((data.begruendung || '').trim() || '—');

  const can_edit = data.canEdit === true || data.canEdit === 'true';
  $('#todo_dwe_complete_edit').closest('li').toggle(can_edit);

  modal.foundation('reveal', 'open');
}

function closeTodoDweCompleteModal() {
  const modal = todoDweCompleteModal();
  if (modal.length) {
    modal.foundation('reveal', 'close');
  }
}

function submitTodoDweComplete() {
  const modal = todoDweCompleteModal();
  const completeUrl = modal.data('completeUrl');
  const $form = $('#todo_dwe_complete_form');
  if (!completeUrl || !$form.length) {
    return;
  }
  $form.attr('action', completeUrl);
  if (typeof SetPageToBusy === 'function') {
    SetPageToBusy();
  }
  $form.trigger('submit');
}

// 260805nrai: same path as pencil — native click so @rails/ujs handles data-remote
function clickTodoEditLink(todoId, editUrl) {
  const editLink = todoId
    ? document.querySelector(`#tr_${todoId} a.todo-edit-link`)
    : null;
  if (editLink) {
    editLink.click();
    return;
  }

  if (!editUrl) {
    return;
  }

  // Fallback: temporary remote link (same as pencil: data-remote + rails-ujs)
  const temporary_link = document.createElement('a');
  temporary_link.href = editUrl;
  temporary_link.setAttribute('data-remote', 'true');
  temporary_link.style.display = 'none';
  document.body.appendChild(temporary_link);
  temporary_link.click();
  temporary_link.remove();
}

function editTodoFromDweCompleteModal() {
  const modal = todoDweCompleteModal();
  const editUrl = modal.data('editUrl');
  const todoId = modal.data('todoId');
  let edit_started = false;

  const start_edit = function () {
    if (edit_started) {
      return;
    }
    edit_started = true;
    clickTodoEditLink(todoId, editUrl);
  };

  // Wait until reveal is fully closed so the overlay does not race the edit load
  modal.one('closed.fndtn.reveal', start_edit);
  closeTodoDweCompleteModal();
  setTimeout(start_edit, 400);
}

// 260819nrai: Typ-Filter je Tab — nur die Zeilen im zugehörigen Panel, kein Seitenreload.
function todosEmptyNoteFor(table) {
  let note = table.parentElement?.querySelector(`[data-todos-empty-for="${table.id}"]`);
  if (note) {
    return note;
  }

  note = document.createElement('p');
  note.className = 'secondary todos-filter-empty';
  note.dataset.todosEmptyFor = table.id;
  note.textContent = 'Keine Todos für diesen Filter.';
  table.insertAdjacentElement('afterend', note);
  return note;
}

function todosRepaintVisibleRows(table) {
  // paint_tr zählt die Kopfzeile mit — sichtbare Datenzeilen starten daher bei 1
  let index = 1;
  table.querySelectorAll('tr.todos-row').forEach((row) => {
    row.classList.remove('rowcolor0', 'rowcolor1');
    if (row.style.display === 'none') {
      return;
    }
    row.classList.add(index % 2 === 0 ? 'rowcolor0' : 'rowcolor1');
    index += 1;
  });
}

function todosRowKind(row) {
  return row.dataset.todoKind || row.getAttribute('data-todo-kind') || '';
}

function todosApplyKindFilter(zone, kind) {
  const panel = zone.closest('[data-todos-scope]');
  if (!panel) {
    return;
  }

  panel.querySelectorAll('table.todos-list').forEach((table) => {
    let visible = 0;
    table.querySelectorAll('tr.todos-row').forEach((row) => {
      const matches = !kind || todosRowKind(row) === kind;
      row.style.display = matches ? '' : 'none';
      if (matches) visible += 1;
    });

    const note = todosEmptyNoteFor(table);
    table.style.display = visible === 0 ? 'none' : '';
    note.style.display = visible === 0 ? '' : 'none';
    todosRepaintVisibleRows(table);
  });

  zone.dataset.activeKind = kind || '';
  zone.querySelectorAll('a[data-kind-filter]').forEach((link) => {
    link.classList.toggle('active', (link.dataset.kindFilter || '') === (kind || ''));
  });
}

function initTodosKindFilter() {
  document.querySelectorAll('[data-todos-kind-filter-zone]').forEach((zone) => {
    if (zone.dataset.bound === '1') {
      return;
    }
    zone.dataset.bound = '1';
    zone.addEventListener('click', function (event) {
      const link = event.target.closest('a[data-kind-filter]');
      if (!link) {
        return;
      }
      event.preventDefault();
      todosApplyKindFilter(zone, link.dataset.kindFilter || '');
    });

    const initialKind = zone.dataset.activeKind || '';
    if (initialKind) {
      todosApplyKindFilter(zone, initialKind);
    }
  });
}

function initTodosUi() {
  initTodosKindFilter();

  $(document).off('click.todoDweComplete', '.todo-dwe-complete-open')
    .on('click.todoDweComplete', '.todo-dwe-complete-open', function (event) {
      event.preventDefault();
      openTodoDweCompleteModal($(this));
    });

  $(document).off('click.todoDweCompleteCancel', '#todo_dwe_complete_cancel')
    .on('click.todoDweCompleteCancel', '#todo_dwe_complete_cancel', function (event) {
      event.preventDefault();
      closeTodoDweCompleteModal();
    });

  $(document).off('click.todoDweCompleteEdit', '#todo_dwe_complete_edit')
    .on('click.todoDweCompleteEdit', '#todo_dwe_complete_edit', function (event) {
      event.preventDefault();
      editTodoFromDweCompleteModal();
    });

  $(document).off('click.todoDweCompleteConfirm', '#todo_dwe_complete_confirm')
    .on('click.todoDweCompleteConfirm', '#todo_dwe_complete_confirm', function (event) {
      event.preventDefault();
      submitTodoDweComplete();
    });
}

export {
  initTodosUi,
  openTodoDweCompleteModal,
  closeTodoDweCompleteModal
};
